import { connect } from 'react-redux';

import styles from './UnlinkAccountModal.module.css';
import { FormattedMessage } from 'react-intl';
import messages from './UnlinkAccountModal.messages';
import { CONFIRM_UNLINKING_ACCOUNT } from '../../TradingData.actions';
import ConfirmationButton from '../../../ui/confirmationButton/ConfirmationButton';
import { CLOSE_MODAL } from '../../../../iwModals/Modals.actions';
import { Prompt } from '../../../ui/prompt/index';

const mapStateToProps = ({ tradingData }) => tradingData;

const mapDispatchToProps = (dispatch) => ({
    confirmUnlinkLinkedAccount: () =>
        dispatch({ type: CONFIRM_UNLINKING_ACCOUNT }),
    closeModal: () => dispatch({ type: CLOSE_MODAL })
});

const UnlinkAccountModal = (props) => {
    const {
        unlinkingLinkedAccountName,
        accountUnlinkingInProgress,
        confirmUnlinkLinkedAccount,
        unlinkingLinkedAccountStatus,
        closeModal
    } = props;
    return (
        <div
            data-testid="unlink-account-modal"
            className={styles.UnlinkAccountModal}
        >
            <h3>
                <FormattedMessage
                    {...messages.title}
                    values={{ bankName: unlinkingLinkedAccountName }}
                />
            </h3>
            <p>
                <FormattedMessage {...messages.subTitle} />
            </p>
            <Prompt>
                <ConfirmationButton
                    className={styles.cancel}
                    onClick={closeModal}
                >
                    <FormattedMessage {...messages.cancel} />
                </ConfirmationButton>
                <ConfirmationButton
                    data-testid="confirm-unlink-account"
                    onClick={confirmUnlinkLinkedAccount}
                    loading={accountUnlinkingInProgress}
                    status={unlinkingLinkedAccountStatus}
                >
                    <FormattedMessage {...messages.unlink} />
                </ConfirmationButton>
            </Prompt>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(UnlinkAccountModal);
